import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Options } from '@popperjs/core';
import { ButtonComponent } from '@shared/button/button.component';
import { DrawingTools } from '@shared/drawing/drawing';
import { ControlPopoverComponent } from '@shared/viewer/viewer-controls/control-popover/control-popover.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-zoom',
  imports: [
    ButtonComponent,
    NgbPopover,
    ControlPopoverComponent,
  ],
  templateUrl: './viewer-zoom.component.html',
  styleUrls: ['./viewer-zoom.component.scss'],
})
export class ViewerZoomComponent implements AfterViewInit {
  zoomLevel = 100;
  statusMessage: string = '';
  isPopoverOpen = false;
  @Input() zoomMin: number = 50;
  @Input() zoomMax: number = 200;
  @Input() zoomIncrement: number = 10;
  @Input() isDesktop: boolean;
  @Output() activeZoomTool: EventEmitter<DrawingTools> = new EventEmitter();
  @Output() zoomPercent: EventEmitter<number> = new EventEmitter();

  protected readonly zbpIconNames = zbpIconNames;

  @ViewChild('popoverControl') popoverControl!: ControlPopoverComponent;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  handleZoomIn(): void {
    if (this.zoomLevel < this.zoomMax) {
      this.zoomLevel += this.zoomIncrement;
    }

    this.setZoomStatusMessage('in');
    this.zoomPercent.emit(this.zoomLevel);
    this.activeZoomTool.emit(DrawingTools.zoomIn);
  }

  handleZoomOut(): void {
    if (this.zoomLevel > this.zoomMin) {
      this.zoomLevel -= this.zoomIncrement;
    }

    this.setZoomStatusMessage('out');
    this.zoomPercent.emit(this.zoomLevel);
    this.activeZoomTool.emit(DrawingTools.zoomOut);
  }

  private setZoomStatusMessage(direction: 'in' | 'out'): void {
    this.statusMessage = `Zoomed ${direction} to ${this.zoomLevel} percent.`;
  }

  resetZoom(): void {
    this.zoomLevel = 100;
    this.statusMessage = `Reset Zoom to ${this.zoomLevel} percent.`;
    this.zoomPercent.emit(100);
  }

  showPopover() {
    this.isPopoverOpen = true;
    this.popoverControl.onPopoverShown();
  }

  closePopover() {
    this.isPopoverOpen = false;
  }

  // Modifying Popper.js options
  popperOptions(options: Options): Options {
    return {
      ...options,
      strategy: 'absolute',
      modifiers: [
        ...(options.modifiers || []),
        {
          name: 'offset',
          options: {
            offset: [0, 0],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            // Allows popover to stay visible even when scrolled
            padding: 0,
          },
        },
      ],
    };
  }
}
